export default __webpack_public_path__ + "static/media/SmartLedge.cd10c645.jpg";